import React from "react";
import { man1 } from "../../Constant/Index";
import ReUse from "../../services/helpers/reUse";
import CustomImage from "../../Components/ReUse/Components/Image";

const ProductReview = (propsData) => {
	const {
		review_id,
		product_id,
		comment,
		rating,
		review_date,
		customer_name,
		customer_img,
		customer_desgination,
	} = propsData ?? {};

	return (
		<>
			<div className="row for-margin">
				<div className="col-md-1">
					<div className="review-img">
						<CustomImage thumbnail={customer_img} />
					</div>
				</div>
				<div className="col-md-11">
					<div className="review-tab-all">
						<div className="tab-text">
							<h5>
								{customer_name}{" "}
								<span> {ReUse.dateFormat({ date: review_date })}</span>
							</h5>
							<p>{comment}</p>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default ProductReview;
